import React from "react";

const FilterSection = ({ filters, handleFilterChange, team, branches, timeSlots, clearFilters }) => {
  const hasActiveFilters = filters.customerName || filters.teamMember || filters.branchPublicId || filters.date || filters.time || (filters.status && filters.status !== "pending");

  return (
    <div className="filter-section">
      <input
        type="text"
        name="customerName"
        placeholder="Filter by customer name or mobile"
        value={filters.customerName}
        onChange={handleFilterChange}
        className="filter-input"
      />
      <select
        name="teamMember"
        value={filters.teamMember}
        onChange={handleFilterChange}
        className="filter-select"
      >
        <option value="">All Team Members</option>
        {team.map(t => <option key={t} value={t}>{t}</option>)}
      </select>
      <select
        name="branchPublicId"
        value={filters.branchPublicId || ""}
        onChange={handleFilterChange}
        className="filter-select"
      >
        <option value="">All Branches</option>
        {branches.map(branch => (
          <option key={branch.publicId} value={branch.publicId}>
            {[branch.branchCode, branch.branchName].filter(Boolean).join(" - ")}
          </option>
        ))}
      </select>
      <input
        type="date"
        name="date"
        value={filters.date}
        onChange={handleFilterChange}
        className="filter-input"
      />
      <select
        name="time"
        value={filters.time}
        onChange={handleFilterChange}
        className="filter-select"
      >
        <option value="">All Times</option>
        {timeSlots.map(t => <option key={t} value={t}>{t}</option>)}
      </select>
      <select
        name="status"
        value={filters.status || "pending"}
        onChange={handleFilterChange}
        className="filter-select"
      >
        <option value="pending">Pending (Not Invoiced/Closed)</option>
        <option value="invoiced">Invoiced</option>
        <option value="closed">Closed</option>
        <option value="follow_up">Online Booking</option>
        <option value="all">All Statuses</option>
      </select>
      {hasActiveFilters && (
        <button className="clear-filter-btn" onClick={clearFilters}>
          Clear Filters
        </button>
      )}
    </div>
  );
};

export default FilterSection;
